<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Checklists'"
      [canGoBack]="true" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    <tidy-card>
      <tidy-card-button (action)="goToUploadList()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/img/integrate.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Upload Checklists'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Upload a CSV file with checklists for your properties.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card>
      <tidy-card-button (action)="startWithTemplate()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/img/star.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Start with Template'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Choose from pre-built checklists to get started quickly.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>

    <tidy-card class="no-margin-bottom">
      <tidy-card-button (action)="setUpManually()">
        <ion-row>
          <tidy-row class="vertical-align-center">
            <tidy-image [src]="'assets/img/todos.svg'" style="width: 20px" />
          </tidy-row>
          <ion-col>
            <tidy-row>
              <tidy-text [header]="'Set Up Manually'" />
            </tidy-row>
            <tidy-row>
              <tidy-text
                [body]="'Set up checklists manually for each property.'" />
            </tidy-row>
          </ion-col>
        </ion-row>
      </tidy-card-button>
    </tidy-card>
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
}

@if (windowService?.isDesktopRes) {
  <ion-content class="ion-content-right-column">
    <ng-container *ngTemplateOutlet="content" />
  </ion-content>
}
